const styles = {
    grayscale_darkest: "#13151A",
    grayscale_darker: "#181B1F",
    grayscale_dark: "#23272E",
    grayscale_dark_50: "#23272E80",
    grayscale_dark_25: "#23272E40",
    grayscale_medium: "#2F3134",
    grayscale_light: "#363B42",
    grayscale_light_50: "#363B42A0",
    grayscale_light_25: "#363B4245",
    grayscale_lighter: "#44494E",
    grayscale_lightest: "#979797",
    border_light: "#FFFFFF12",
    border_lighter: "#FFFFFF33",
    white: "#FFFFFF",
    white_opacity_75: "rgba(255, 255, 255, 0.75)",
    accent_light: "#74FFF1",
    accent: "#5DC6BD",
    accent_dark: "#203133",
    alert: "#FF7474",
    alert_background: "#693638",
    box_shadow: "5px 5px 9px 0px rgba(0,0,0,0.44)",
    // OKLCH colors
    muted: "hsl(0,0%,97%)",
    muted_foreground: "hsl(248,4%,60%)",
    foreground: "hsl(248,2%,98%)",
    secondary_foreground: "hsl(271,5%,70%)",
    inverse_foreground: "hsl(268,11%,20%)",
    border: "hsla(0,0%,100%,0.1)",
    input: "hsla(0,0%,100%,0.1)",
    ring: "hsla(0,0%,100%,0.1)"
};
export { styles };
